import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../../Common/SharedComponents";
import { BedAndProductWrapperInstructionModel } from "../../../../../../../Wrap/Models/Domains/BedAndProductWrapper/BedAndProductWrapperInstructionModel";
import { PPToProductLables } from "../../Resource/Contents";
interface IChooseAssetsToSellProps extends IProcessComponentProps {
    data: BedAndProductWrapperInstructionModel;
    asset: any;
}

interface IChooseAssetsToSellState {}

export class ChooseAssetsToSell extends ProcessComponent<IChooseAssetsToSellProps, IChooseAssetsToSellState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.data.IsAcrossAllAssets == null) {
            this.props.onChange({ IsAcrossAllAssets: true });
        }
        if (this.props.data.IsAcrossAllAssets) {
            const sellAllocations = this.adjustAssets(this.props.asset);
            this.props.onChange({ SellAllocations: sellAllocations });
        }
    }

    private adjustAssets(passedAssets) {
        let assets = passedAssets.filter(asset => asset.MarketValue.Amount > 0);

        const totalAmount = assets.reduce((total, asset) => total + asset.MarketValue.Amount, 0);
        let adjustedAssets = assets.map(asset => ({
            Name: asset.AssetName,
            Percentage: (asset.MarketValue.Amount / totalAmount) * 100,
            ProductId: asset.ProductId,
            Type: asset.ProductType,
        }));
    
        let totalPercentage = adjustedAssets.reduce((sum, asset) => sum + asset.Percentage, 0);
        let remainder = 100 - totalPercentage;
    
        if (adjustedAssets.length > 0) {
            for (let i = 0; i < Math.abs(remainder * 100); i++) {
                if (remainder > 0) {
                    adjustedAssets[i % adjustedAssets.length].Percentage += 0.01;
                } else {
                    adjustedAssets[i % adjustedAssets.length].Percentage -= 0.01;
                }
            }
        }
    
        return adjustedAssets;
    }

    public render(): JSX.Element {
        const { data, onChange} = this.props;
        return (
            <>
                {SectionHeader(PPToProductLables.investmentsToSell)}
                
                <RadiosEditor
                    options={[true, false]}
                    label={PPToProductLables.withdrawalMethod}
                    getText={(v) => (v ? "Proportionally across all assets" : "From specified assets")}
                    onChange={(v) => {
                        const sellAllocations = v ? this.adjustAssets(this.props.asset) : [];
                        onChange({ IsAcrossAllAssets: v, SellAllocations: sellAllocations });
                    }}
                    // tooltip={
                    //     "If there is insufficient value in an asset at the time of the sale, we will default to disinvesting proportioanlly from the assets selected."
                    // }
                    cssWrapper={"rg-inline mb-10"}
                    selected={data?.IsAcrossAllAssets}
                />
            </>
        );
    }
}
